import React, { useState } from "react";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  LoadingComponent,
  PreviewCard,
  ReactDataTable,
  StatusActiveDropDown,
} from "../../../../components/Component";
import AddHoliday from "./AddHoliday";
import { holidayDataTableColumns, listHolidayAPI } from "./holidayTableData";
import { ServerStatusType } from "../../../../utils";
import { useEffect } from "react";
import { ImportExportButton } from "../../../../components/button/ActionButton";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../../services/permission/permission";

const HolidayList = () => {
  const [holidayListData, setHolidayListData] = useState([]);
  const [status, setStatus] = useState();
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadHoliday();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status) {
      loadHoliday();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const onEdit = (row) => {
    setSelectedItem(row);
    setModal(true);
  };

  function loadHoliday() {
    if (isCheckToList(UserPermissionType.holiday)) {
      setLoading(true);
      listHolidayAPI({ status: status?.value ?? ServerStatusType.active }, (list, error) => {
        if (error === null) {
          setHolidayListData(list);
          setLoading(false);
        }
      });
    }
  }

  return (
    <React.Fragment>
      <Head title="Holidays" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Holidays</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="d-flex align-items-center">
                <span className="me-2">
                  <StatusActiveDropDown
                    value={status}
                    className="w-100px "
                    onSelect={(e) => {
                      setStatus(e);
                    }}
                  />
                </span>
                {isAllowToAccess(UserPermissionType.holiday, UserActionType.add) && (
                  <span>
                    <ImportExportButton addButton title={"Add"} onClick={() => setModal(true)} iconName={"plus"} />
                  </span>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard>
            <ReactDataTable
              data={holidayListData}
              columns={holidayDataTableColumns(onEdit)}
              isAllowed={isCheckToList(UserPermissionType.holiday)}
            />
          </PreviewCard>
        </Block>
        <AddHoliday
          visible={modal}
          item={selectedItem}
          onClosed={() => {
            setModal(false);
            setSelectedItem();
          }}
          onSaved={() => {
            loadHoliday();
          }}
        />
        <LoadingComponent isLoading={loading} />
      </Content>
    </React.Fragment>
  );
};

export default HolidayList;
